import React, { Component } from 'react';
import Icon from '../Icon';
import range from 'lodash/range';
import './styles.scss';

class ServerTable extends Component {
	render(){
		const { headers, data, page, changePage, totalPages } = this.props;
		return (
			<div  className='ServerTable'>
				{headers && (
	        <div className="ServerTable-head">
						{headers.map((header, i) => (
             	<span key={i} className="ServerTable-column"
								style={{ ...header.style, width: header.width }}
								colSpan={header.colSpan || 1}>
								{header.content}
							</span>
						))}
	        </div>
	      )}
				{data && (
					<div className="ServerTable-body">
						{data &&
                data.map((row, i) => (
                	<div key={i} className="ServerTable-row">
                		{row.map((cell, y) => (
                			<span key={y} className="ServerTable-column"
                				style={{...cell.style, width: headers[y].width }}
                				colSpan={cell.colSpan || 1}>
                				{cell.content}
                			</span>
                		))}
                	</div>
                ))}
					</div>
				)}
				<div className="ServerTable-Pagination">
					<button
						disabled={page === 1}
						className="ServerTable-Pagination-previous"
						onClick={() => changePage(page - 1)}
					>
						<Icon icon={'arrowDown'} />
						<span>Previous</span>
					</button>
					{
						page > 3 && <button
							key={'begin'}
							className={'ServerTable-Pagination-page'}
							onClick={() => changePage(1)}
						>
							{1}
						</button>
					}
					{
						page > 3 && '…'
					}
					{
						range( Math.max( 1 , page - 2), Math.min( totalPages + 1 , page + 3) ).map(pageIndex => {
							const pageClass = [
								'ServerTable-Pagination-page',
								page === pageIndex ? 'is-active' : ''
							].join(' ');
							return (
								<button
									key={pageIndex}
									className={pageClass}
									onClick={() => changePage(pageIndex)}
								>
									{pageIndex}
								</button>
							);
						})
					}
					{
						totalPages > page + 3 && '…'
					}
					{
						totalPages > page + 3 && <button
							key={'end'}
							className={'ServerTable-Pagination-page'}
							onClick={() => changePage(totalPages)}
						>
							{totalPages}
						</button>
					}
					<button
						disabled={page === totalPages}
						className="ServerTable-Pagination-next"
						onClick={() => changePage(page + 1)}
					>
						<span>Next</span>
						<Icon icon={'arrowDown'} />
					</button>
				</div>
			</div>
		)
	}
}

export default ServerTable;
